import React, { Component } from 'react';
import styled from 'styled-components';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import HelpSection from './HelpSection';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import { setWindowHash } from '../../../../lib/utils';
import { onCTAClick } from '../../../../lib/atm';

const TitleH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  color: ${(p) => p.theme.c.text.primary};
  margin-top: ${(p) => p.theme.unit(8)};
`;

const SubHeaderDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.text.primary};
  margin-top: ${(p) => p.theme.unit(2)};
  margin-bottom: ${(p) => p.theme.unit(6)};
  
  strong {
    font-weight: var(--typography-font-weight-bold);
  }
`;

class HelpPageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedQuestions: {},
    };

    this.handleQuestionSelect = this.handleQuestionSelect.bind(this);
  }

  handleQuestionSelect(sectionSlug, questionSlug, event) {
    event.preventDefault();
    event.stopPropagation();
    if(event.detail ===1 || event.key === 'Enter' || event.charCode === 32){
      const selectedQuestions = Object.assign({}, this.state.selectedQuestions);

      const isOpeningAction = !selectedQuestions[questionSlug];

      selectedQuestions[questionSlug] = !selectedQuestions[questionSlug];

      if (isOpeningAction && event) {
        onCTAClick(event);
      }

      this.setState({ selectedQuestions });
      setWindowHash(sectionSlug, questionSlug);
    }
  }

  render() {
    const {
      displayName = '',
      helpPageData = {},
    } = this.props;

    const {
      helpSections = [],
      subHeaderText = '',
    } = helpPageData;

    const createHelpSection = (isMobile) => {
      return helpSections
        .map((section) => {
          return (
            <HelpSection
              key={`help-section-${section.slug}`}
              isMobile={isMobile}
              helpSectionData={section}
              onQuestionSelect={this.handleQuestionSelect}
              selectedQuestions={this.state.selectedQuestions}
            />
          );
        });
    };

    const subHeaderTextToRender = (
      <SubHeaderDiv dangerouslySetInnerHTML={{
        __html: subHeaderText,
      }} />
    );

    const desktopPage = (
      <MaxWidthLayout>
        <TitleH1>{ displayName }</TitleH1>
        { subHeaderTextToRender }
        { createHelpSection(false) }
      </MaxWidthLayout>
    );

    const mobilePage = (
      <MaxWidthLayout>
        <TitleH1 isMobile>{ displayName }</TitleH1>
        { subHeaderTextToRender }
        { createHelpSection(true) }
      </MaxWidthLayout>
    );

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={desktopPage}
        mobileChildren={mobilePage}
      />
    );

    return renderComp;
  }
}

export default HelpPageContent;
